import $ from 'jquery'
$(document).ready(function () {

    var screen = window.outerWidth;
    if (screen < 798) {
        $('.page-sidebar ').addClass("close_icon");
    }
    $('body').on('click', '.action_icon', function () {
        $(".action-list-box").animate({
            width: "0px",
        }, 100);

        var spnid = $(this).attr("attribute-id");
        var length = ($(".sixelement" + spnid).find('a').length);
        var dWidth = parseInt((53 * length) + 32);

        $(".spn" + spnid).animate({
            width: "310px",
        }, 200);
        $(".sixelement" + spnid).animate({
            'width': dWidth + "px",


        }, 200);

        $(".sixelement" + spnid).animate({
            'width': dWidth + "px",


        }, 200);
        $(".sevenelement" + spnid).animate({
            width: "350px",

        }, 200);
    });
    $('body').on('click', '.close-action', function () {


        $(".action-list-box").animate({
            width: "0px",

        }, 100);
    });

    $(document).on("click", ".profile-avatar", function () {

        $(this).toggleClass("profile-menu");

    });

    //nav-page-sidebar
    //page-sidebar close_icon

    $(document).on("click", ".sub_moduleRoute", function () {
        var spnid = $(this).attr("attribute-id");
        $(".sidebar-link, .sub_moduleRoute ").removeClass("cust-active-module");
        $('.single_click').removeClass("active");
        $('.multiple_click ').removeClass("active");
        $('.addhighlited_' + spnid).addClass("active");

    });
    //sidebar-link my-click

    $(document).on("click", ".single_click ", function () {
        var spnid = $(this).attr("attribute-id");
        $(".sidebar-link, .sub_moduleRoute ").removeClass("cust-active-module");
        //collapsed
        $('.single_click').removeClass("active");
        $('.multiple_click ').removeClass("active");
        $('.menuElelment_' + spnid).addClass("active");
    })
})














